export default __webpack_public_path__ + "static/media/thin-cross.a824c1a5.svg";